import React from 'react'

const AboutMe = () => {
  return (
  
    <div className='AboutMe'>
        <h1>About Me</h1>
        
        Coding combines my two passions: my creativity I’ve honed for 12 years in visual arts and my love for solving technical problems that I developed after 5 years in robotics. I’ve entered into a college-level arts competition Vase and received multiple perfect scores for work in sculpture. Additionally, I’ve been involved with the hardware side of things such as robotics through competing at state and national levels, and then completed college courses in industrial machine learning. Now I’m thrilled to use those skills to make beautifully designed and secure fullstack applications. 
    </div>
  )
}

export default AboutMe